import formFilterData from "@/components/mixins/form-filter-data"
import formFields from "@/components/mixins/form-fields"

export default {
	mixins: [formFilterData, formFields],
	data: function () {
		return {
			isNew: false,
			isDetail: false,
			entityName: 'subscriber',
			moduleName: 'subscribers',
			detailPageRouteName: 'subscriberDetail',
			requiredNewBillerFields: ['firstname', 'surname'],
			requiredSubscriberFields: ['firstname', 'surname'],
			updateFields: [
				'id',
				'id_remote',
				'id_type',
				'id_operator',
				'login',
				'subscription_type',
				'promo_to',
				'shape',
				'active',
				'active_from',
				'active_to',
				'firstname',
				'surname',
				'subject_type',
				'company_name',
				'cin',
				'tin',
				'email',
				'phone',
				'tag_ids',
				'maximum_paired_device_count',
				'parental_lock_pin',
				'force_pin_change',
				'address',
				'note',
				'no_cache',
				'permissions_subscriber_profiles_restricted_create',
				'permissions_subscriber_profiles_restricted_update',
				'permissions_subscriber_profiles_restricted_delete',
			],
			entity: {address: {country: 'CZE'}, subscriber_services: {}, active_from: null, active_to: null, tag_ids: []},
			services: [],
			newBiller: {
				id_operator: null,
				firstname: '',
				surname: '',
				subject_type: 'person',
				address: {country: 'CZE'}
			},
			newDevice: {name: '', mac_address: ''},
			newPairingCode: {name: '', expiration_date: ''},
			newPassword: null
		}
	},
	methods: {
		resetNewBiller() {
			this.newBiller = {id_operator: null, subject_type: 'person', address: {country: 'CZE'}}
			this.newBiller['id_operator'] = this.entity.id_operator
			this.$refs['subscriberDetailBiller'].resetFields()
			this.$refs['subscriberDetailBiller'].setOwnId(null)
		},
		resetNewDevice() {
			this.newDevice = {name: '', mac_address: ''}
			this.$refs['devicesref'].resetNewDevice()
		},
		resetNewPairingCode() {
			this.newPairingCode = {'name': '', 'expiration_date': ''}
			this.$refs['devicesref'].resetNewPairingCode()
		},
		_afterFilterFormParamsActions(params, allowed) {
			if (this.newPassword !== null) {
				allowed['password'] = this.newPassword
			}
			return allowed
		},
		setNewPassword(value) {
			this.newPassword = value
		}
	}
}



// WEBPACK FOOTER //
// ./src/components/mixins/subscriber-data.js